import request from '../request'

// 获取组织转接列表
export function getOrgTransferList(params) {
  return request({
    url: '/app/org/transfer/list',
    method: 'get',
    params,
  })
}

// 获取组织转接详情
export function getOrgTransferDetail(params) {
  return request({
    url: '/app/org/transfer/detail',
    method: 'get',
    params,
  })
}
